<template>
  <v-sheet class="ml-8 mt-4" max-width="280" color="transparent">
    <v-select
      v-model="selectedSortItem"
      :items="sortItems"
      item-text="text"
      item-value="key"
      dense
      :label="selectedTitle"
      @change="changeSortOrderItem"
    ></v-select>
  </v-sheet>
</template>

<script>
import i18n from '@/lib/i18n'
import * as Constants from '@/lib/constants'

export default {
  name: 'FieldSortOrderComponent',
  data() {
    return {
      selectedTitle: i18n.tt('sortOptions.title'),
      selectedSortItem: Constants.SortOrder.Field.Name.keyName,
      sortItems: [
        {
          text: i18n.tt(Constants.SortOrder.Field.Name.textValue),
          key: Constants.SortOrder.Field.Name.keyName,
          direction: Constants.SortOrder.Field.Name.direction,
        },
        {
          text: i18n.tt(Constants.SortOrder.Field.CreatedAt.textValue),
          key: Constants.SortOrder.Field.CreatedAt.keyName,
          direction: Constants.SortOrder.Field.CreatedAt.direction,
        },
      ], // LastModifiedDateTimeは未使用
    }
  },
  mounted() {
    const sortItem = this.sortItems.find(item => item.key === this.selectedSortKey)
    this.selectedSortItem = sortItem
  },
  methods: {
    changeSortOrderItem(sortKey) {
      const sortItem = this.sortItems.find(item => item.key === sortKey)
      const params = { key: sortItem.key, direction: sortItem.direction }
      this.$store.dispatch('changeSortOrderItem', params)
    },
  },
  computed: {
    selectedSortKey() {
      return this.$store.getters.sortOptions.fields.key
    },
  },
}
</script>
